<template>
  <div>
    нажми для открытия
  </div>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";
import ClickToEdit from "@/components/ClickToEdit";

export default {
  name: "quantity-card-scale-view",
  mixins: [dynamicScaleComponent],
  components: {ClickToEdit},

  props: {
    disabled:{type: Boolean, default: false}
  },
  data() {
    return {
      scale:{
        fact: null,
        scopes: [],
      },
    }
  },
  methods: {}
}
</script>